/**
 * Mega Menu JavaScript
 * Handles desktop hover and mobile toggle functionality
 */

document.addEventListener('DOMContentLoaded', function() {
    const navbar = document.querySelector('.navbar-nav');
    if (!navbar) return;
    
    // Desktop functionality
    if (window.innerWidth >= 768) {
        // Prevent dropdown from closing when clicking inside mega menu
        const megaMenus = document.querySelectorAll('.has-mega-menu .dropdown-menu');
        megaMenus.forEach(menu => {
            menu.addEventListener('click', function(e) {
                e.stopPropagation();
            });
        });
        
        // Handle hover for desktop with improved stability
        const dropdowns = document.querySelectorAll('.navbar-nav .dropdown');
        dropdowns.forEach(dropdown => {
            let hoverTimeout;
            let isOverDropdown = false;
            let isOverMenu = false;
            
            // Track mouse over dropdown toggle
            dropdown.addEventListener('mouseenter', function() {
                isOverDropdown = true;
                clearTimeout(hoverTimeout);
                const menu = this.querySelector('.dropdown-menu');
                if (menu) {
                    // Close other dropdowns
                    document.querySelectorAll('.navbar-nav .dropdown-menu.show').forEach(m => {
                        if (m !== menu) m.classList.remove('show');
                    });
                    menu.classList.add('show');
                }
            });
            
            // Track mouse leaving dropdown toggle
            dropdown.addEventListener('mouseleave', function(e) {
                isOverDropdown = false;
                const menu = this.querySelector('.dropdown-menu');
                if (menu) {
                    // Only close if not hovering over the menu itself
                    hoverTimeout = setTimeout(() => {
                        if (!isOverMenu && !isOverDropdown) {
                            menu.classList.remove('show');
                        }
                    }, 100); // Reduced timeout for better responsiveness
                }
            });
            
            // Track mouse over dropdown menu
            const menu = dropdown.querySelector('.dropdown-menu');
            if (menu) {
                menu.addEventListener('mouseenter', function() {
                    isOverMenu = true;
                    clearTimeout(hoverTimeout);
                    this.classList.add('show');
                });
                
                menu.addEventListener('mouseleave', function(e) {
                    isOverMenu = false;
                    // Only close if not hovering over the parent dropdown
                    hoverTimeout = setTimeout(() => {
                        if (!isOverDropdown && !isOverMenu) {
                            this.classList.remove('show');
                        }
                    }, 100);
                });
            }
        });
        
        // Disable Bootstrap's click toggle on desktop
        const dropdownToggles = document.querySelectorAll('.navbar-nav .dropdown-toggle');
        dropdownToggles.forEach(toggle => {
            toggle.addEventListener('click', function(e) {
                e.preventDefault();
                // Allow navigation to parent link
                if (this.getAttribute('href') && this.getAttribute('href') !== '#') {
                    window.location.href = this.getAttribute('href');
                }
            });
        });
    }
    
    // Mobile functionality
    if (window.innerWidth < 768) {
        // Remove Bootstrap dropdown attributes for mobile
        const dropdownToggles = document.querySelectorAll('.navbar-nav .dropdown-toggle');
        dropdownToggles.forEach(toggle => {
            toggle.removeAttribute('data-bs-toggle');
            toggle.setAttribute('aria-expanded', 'false');

            // Add click handler for mobile accordion toggle
            toggle.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                const dropdown = this.closest('.dropdown, .menu-item');
                const menu = dropdown.querySelector('.dropdown-menu');

                if (menu) {
                    const isOpen = menu.classList.contains('show');

                    // Close ALL other top-level menus (accordion behavior - one at a time)
                    const allTopLevelMenus = dropdown.parentElement.querySelectorAll(':scope > .dropdown, :scope > .menu-item');
                    allTopLevelMenus.forEach(sibling => {
                        if (sibling !== dropdown) {
                            const siblingMenu = sibling.querySelector('.dropdown-menu');
                            const siblingToggle = sibling.querySelector('.dropdown-toggle, .nav-link');
                            if (siblingMenu && siblingMenu.classList.contains('show')) {
                                siblingMenu.classList.remove('show');
                                if (siblingToggle) {
                                    siblingToggle.setAttribute('aria-expanded', 'false');
                                }
                            }
                        }
                    });

                    // Toggle current menu
                    if (isOpen) {
                        menu.classList.remove('show');
                        this.setAttribute('aria-expanded', 'false');
                    } else {
                        menu.classList.add('show');
                        this.setAttribute('aria-expanded', 'true');
                    }
                }
            });
        });

        // Handle regional sub-accordion clicks (for nested accordions within mega menus)
        const setupRegionalAccordions = () => {
            const regionHeaders = document.querySelectorAll('.region-header.collapsible, .mega-menu-heading.collapsible');

            regionHeaders.forEach(header => {
                header.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();

                    const regionalGroup = this.closest('.regional-group, .mega-menu-col');
                    if (!regionalGroup) return;

                    const regionItems = regionalGroup.querySelector('.region-items');
                    if (!regionItems) return;

                    const isOpen = regionItems.classList.contains('show');

                    // Close other regional groups in the same parent menu
                    const parentMenu = this.closest('.dropdown-menu');
                    if (parentMenu) {
                        const allRegionalItems = parentMenu.querySelectorAll('.region-items.show');
                        allRegionalItems.forEach(items => {
                            if (items !== regionItems) {
                                items.classList.remove('show');
                                const siblingHeader = items.previousElementSibling;
                                if (siblingHeader && siblingHeader.classList.contains('collapsible')) {
                                    siblingHeader.classList.remove('expanded');
                                }
                            }
                        });
                    }

                    // Toggle current regional group
                    if (isOpen) {
                        regionItems.classList.remove('show');
                        this.classList.remove('expanded');
                    } else {
                        regionItems.classList.add('show');
                        this.classList.add('expanded');
                    }
                });
            });
        };

        // Setup regional accordions after a short delay to ensure DOM is ready
        setTimeout(setupRegionalAccordions, 100);

        // Also setup when navbar collapse is shown (in case menu is loaded dynamically)
        const navbarCollapse = document.getElementById('navbar');
        if (navbarCollapse) {
            navbarCollapse.addEventListener('shown.bs.collapse', setupRegionalAccordions);
        }

        // Close all menus when clicking outside
        document.addEventListener('click', function(e) {
            if (!e.target.closest('.navbar-nav') && !e.target.closest('.navbar-toggler')) {
                const openMenus = document.querySelectorAll('.navbar-nav .dropdown-menu.show');
                openMenus.forEach(menu => {
                    menu.classList.remove('show');
                    const toggle = menu.previousElementSibling;
                    if (toggle && toggle.classList.contains('dropdown-toggle')) {
                        toggle.setAttribute('aria-expanded', 'false');
                    }
                });
            }
        });

        // Close all menus when hamburger is clicked to close navbar
        const navbarToggler = document.querySelector('.navbar-toggler');
        if (navbarToggler && navbarCollapse) {
            navbarToggler.addEventListener('click', function() {
                // Only close menus if navbar is currently shown
                if (navbarCollapse.classList.contains('show')) {
                    const openMenus = navbarCollapse.querySelectorAll('.dropdown-menu.show');
                    openMenus.forEach(menu => {
                        menu.classList.remove('show');
                        const toggle = menu.previousElementSibling;
                        if (toggle && toggle.classList.contains('dropdown-toggle')) {
                            toggle.setAttribute('aria-expanded', 'false');
                        }
                    });
                }
            });
        }
    }
    
    // Handle window resize without reloading
    // Only reinitialize menus when crossing the mobile/desktop breakpoint
    let resizeTimer;
    let previousWidth = window.innerWidth;
    
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            const currentWidth = window.innerWidth;
            // Check if we've crossed the breakpoint
            const crossedBreakpoint = (previousWidth < 768 && currentWidth >= 768) || 
                                   (previousWidth >= 768 && currentWidth < 768);
            
            if (crossedBreakpoint) {
                // Store the new width
                previousWidth = currentWidth;
                // Reload only when crossing breakpoint to apply correct behavior
                location.reload();
            }
        }, 500);
    });
});

// Ensure Bootstrap is loaded
if (typeof bootstrap !== 'undefined') {
    // Override Bootstrap dropdown behavior
    const dropdowns = document.querySelectorAll('[data-bs-toggle="dropdown"]');
    dropdowns.forEach(dropdown => {
        const bsDropdown = new bootstrap.Dropdown(dropdown, {
            autoClose: false
        });
    });
}